<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-cascades"></i>交易明细
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="handle-box">
        <!-- <el-select v-model="query.address" placeholder="输入商户号查找" class="handle-select mr10">
                    <el-option key="1" label="广东省" value="广东省"></el-option>
                    <el-option key="2" label="湖南省" value="湖南省"></el-option>
                </el-select> -->
        <el-date-picker
         style="width: 250px;"
          v-model="value1"
          value-format="yyyy-MM-dd HH:mm:ss"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
        <el-select
          v-if="!auth"
          style="width: 200px; margin-left: 20px"
          v-model="query.id"
          filterable
          remote
          reserve-keyword
          placeholder="请输入商户名称搜索"
          :remote-method="remoteMethod1"
          :loading="searchloading"
        >
          <el-option
            v-for="item in comList"
            :key="item.id"
            :label="item.company_name"
            :value="item.id"
          >
            <span style="float: left">{{ item.company_name }}</span>
            <span style="float: right; color: #8492a6; font-size: 13px"
              >商户号:{{ item.company_mid }}</span
            >
          </el-option>
        </el-select>
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="handleSearch"
          style="margin-left: 10px"
          >搜索
        </el-button>
        <el-button type="primary" @click="reset" style="margin-left: 10px"
          >重置
        </el-button>
 <el-tag size="medium" style="margin-right: 10px;margin-left: 10px"
          >交易额合计:{{ getMoney(sum) }}</el-tag
        >
        <el-tag size="medium" style="margin-right: 10px" type="danger"
          >服务费合计:{{ getMoney(dis_sum) }}</el-tag
        >

        <el-button
          type="primary"
          icon="el-icon-upload2"
          style="float: right"
          @click="editVisible = true"
          >导出表格
        </el-button>
      </div>
      <el-table
        v-loading="loading"
        :data="tableData"
        border
        class="table"
        ref="multipleTable"
        header-cell-class-name="table-header"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="55"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="id"
          label="ID"
          width="55"
          align="center"
        ></el-table-column>
        <el-table-column prop="merorderid" label="订单号"></el-table-column>
        <el-table-column prop="company_name" label="商户名称"></el-table-column>
        <el-table-column prop="company_mid" label="商户号"></el-table-column>
        <el-table-column label="交易金额">
          <template slot-scope="scope">￥{{ scope.row.totalamount }}</template>
        </el-table-column>
        <el-table-column label="支付方式">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.pay_type == 1" type="success"
              >微信支付</el-tag
            >
            <el-tag v-if="scope.row.pay_type == 2">支付宝支付</el-tag>
            <el-tag v-if="scope.row.pay_type == 3">云闪付</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="服务费">
          <template slot-scope="scope">￥{{ scope.row.dis_money }}</template>
        </el-table-column>
        <el-table-column label="实际收入">
          <template slot-scope="scope">￥{{ scope.row.com_money }}</template>
        </el-table-column>
        <el-table-column label="备注" prop="message" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.message }}</span>
          </template>
        </el-table-column>

        <!-- <el-table-column prop="address" label=""></el-table-column>
                <el-table-column prop="address" label=""></el-table-column> -->
        <el-table-column prop="tradetime" label="交易时间"></el-table-column>
      </el-table>
      <div class="pagination">
     
        <template v-if="user_login_auth == 1">
          <el-tag size="medium" style="margin-right: 20px"
            >微信交易额合计:{{ getMoney(wxsum) }}</el-tag
          >
          <el-tag size="medium" style="margin-right: 20px"
            >支付宝交易额合计:{{ getMoney(zfbsum) }}</el-tag
          >
          <el-tag size="medium" style="margin-right: 20px"
            >云闪付交易额合计:{{ getMoney(ysfsum) }}</el-tag
          >
        </template>

       
        <el-pagination
          style="float: right"
          background
          layout="total, prev, pager, next"
          :current-page="query.page"
          :page-size="query.limit"
          :total="pageTotal"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </div>
    <!-- 编辑弹出框 -->
    <el-dialog
      title="导出表格"
      :visible.sync="editVisible"
      width="600px"
      @close="closeDialog"
    >
      <el-form label-width="80px">
        <el-form-item label="时间范围:">
          <el-date-picker
            v-model="value2"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetimerange"
            separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="商户号:" v-if="!auth">
          <el-select
            style="width: 300px"
            v-model="mid"
            filterable
            remote
            reserve-keyword
            placeholder="请输入商户名称搜索"
            :remote-method="remoteMethod1"
            :loading="searchloading"
            clearable="ture"
          >
            <el-option
              v-for="item in comList"
              :key="item.id"
              :label="item.company_name"
              :value="item.id"
            >
              <span style="float: left">{{ item.company_name }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px"
                >商户号:{{ item.company_mid }}</span
              >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editVisible = false">取 消</el-button>
        <el-button type="primary" @click="getList" v-loading="btnLoading"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { fetchData } from "../../api/index";
export default {
  name: "basetable",
  data() {
    return {
      btnLoading: false,
      dowloadList: [],
      searchloading: false,
      comList: [],
      auth: sessionStorage.getItem("merchants_id") ? true : false,
      loading: false,
      mid: sessionStorage.getItem("merchants_id")
        ? sessionStorage.getItem("merchants_id")
        : "",
      query: {
        id: sessionStorage.getItem("merchants_id")
          ? sessionStorage.getItem("merchants_id")
          : "",
        company_name: "",
        start_time: "",
        end_time: "",
        auth: "",
        limit: 10,
        page: 1,
      },
      optiosn: [],
      tableData: [],
      multipleSelection: [],
      delList: [],
      editVisible: false,
      pageTotal: 0,
      form: {},
      idx: -1,
      id: -1,
      value1: ["", ""],
      value2: ["", ""],
      sum: 0,
      com_money: "",
      dis_sum: 0,
      user_login_auth: 0,
      wxsum:0,
      zfbsum:0,
      ysfsum:0
    };
  },
  created() {
    this.getData();
    this.user_login_auth = sessionStorage.getItem("user_login_auth");
    console.log(this.user_login_auth);
  },
  activated() {
    this.getData();
  },
  methods: {
    getMoney(val) {
      if (val) {
        if (val > 100000000) {
          return (val / 100000000).toFixed(2) + "亿";
        }
        return val;
      } else {
        return 0;
      }
    },
    closeDialog() {
      this.value2 = ["", ""];
      this.mid = "";
    },
    reset() {
      this.query.auth = this.query.id == "" ? "1" : "2";
      this.value1 = ["", ""];
      this.getData();
    },
    remoteMethod1(query) {
      if (query !== "") {
        this.searchloading = true;
        setTimeout(() => {
          let searchQuery = {
            id: "",
            auth: "1",
            limit: 8,
            page: 1,
            company_name: query,
          };
          let url = this.$apiUrl.merchant.getMerchant;
          this.$post(url, this.$params(searchQuery)).then((res) => {
            if (res.data.code == 200) {
              this.searchloading = false;
              this.comList = res.data.data.list;
              console.log(this.comList);
            }
          });
        }, 200);
      } else {
        this.comList = [];
      }
    },
    getList(a) {
      console.log(a);
      if (!this.btnLoading) {
        this.btnLoading = true;
        let that = this;
        let url = that.$apiUrl.order.getOrder;
        let query = {
          id: sessionStorage.getItem("merchants_id")
            ? sessionStorage.getItem("merchants_id")
            : that.mid,
          start_time: "",
          end_time: "",
          auth: "",
          limit: 10000,
          page: 1,
          company_name: "",
        };
        query.auth = query.id == "" ? "1" : "2";
        if (that.value2) {
          query.start_time = that.value2[0];
          query.end_time = that.value2[1];
        } else {
          query.start_time = "";
          query.end_time = "";
        }
        console.log(query);

        that
          .$post(url, that.$params(query))
          .then((res) => {
            if (res.data.code == 200) {
              that.dowloadList = res.data.data.list;
              this.epexortExcel();
            }
          })
          .catch((error) => {
            this.$message.error(error);
            that.btnLoading = false;
          });
      }
    },
    getData() {
      let that = this;
      let url = that.$apiUrl.order.getOrder;
      that.query.auth = that.query.id == "" ? "1" : "2";
      if (that.value1) {
        that.query.start_time = that.value1[0];
        that.query.end_time = that.value1[1];
      } else {
        that.query.start_time = "";
        that.query.end_time = "";
      }
      that.loading = true;
      that
        .$post(url, that.$params(that.query))
        .then((res) => {
          if (res.data.code == 200) {
            that.loading = false;
            that.pageTotal = res.data.data.count;
            that.tableData = res.data.data.list;
            that.sum = res.data.data.sum;
            that.wxsum=res.data.data.wx;
            that.ysfsum=res.data.data.ysf;
            that.zfbsum=res.data.data.zfb;
            that.dis_sum = res.data.data.dis_sum;
          }
        })
        .catch((error) => {
          that.loading = false;
          this.$message.error(error);
        });
    },
    epexortExcel() {
      const { export_json_to_excel } = require("../../api/Export2Excel.js");
      const tHeader = [
        "编号",
        "订单号",
        "商户名称",
        "交易金额",
        "服务费",
        "实际收入",
        "备注",
        "交易时间",
      ];
      // 上面设置Excel的表格第一行的标题
      const filterVal = [
        "id",
        "merorderid",
        "company_name",
        "totalamount",
        "dis_money",
        "com_money",
        "message",
        "tradetime",
      ];
      // 上面的index、nickName、name是tableData里对象的属性
      const list = this.dowloadList; //把data里的tableData存到list
      const data = this.formatJson(filterVal, list);
      export_json_to_excel(tHeader, data, "订单信息表");
      this.btnLoading = false;
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    // 获取 easy-mock 的模拟数据

    // 触发搜索按钮
    handleSearch() {
      this.$set(this.query, "page", 1);
      this.getData();
    },
    // 删除操作
    handleDelete(index, row) {
      // 二次确认删除
      this.$confirm("确定要删除吗？", "提示", {
        type: "warning",
      })
        .then(() => {
          this.$message.success("删除成功");
          this.tableData.splice(index, 1);
        })
        .catch(() => {});
    },
    // 多选操作
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    delAllSelection() {
      const length = this.multipleSelection.length;
      let str = "";
      this.delList = this.delList.concat(this.multipleSelection);
      for (let i = 0; i < length; i++) {
        str += this.multipleSelection[i].name + " ";
      }
      this.$message.error(`删除了${str}`);
      this.multipleSelection = [];
    },
    // 编辑操作
    handleEdit(index, row) {
      this.idx = index;
      this.form = row;
      this.editVisible = true;
    },
    // 保存编辑
    saveEdit() {
      this.editVisible = false;
      this.$message.success(`修改第 ${this.idx + 1} 行成功`);
      this.$set(this.tableData, this.idx, this.form);
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, "page", val);
      this.getData();
    },
  },
  computed: {
    strNull() {
      return function (val) {
        if (val == "null") {
          return null;
        } else {
          return val;
        }
      };
    },
  },
  watch: {
    tableData() {
      this.tableData.forEach((item, index) => {
        if (item.message == "null") {
          item.message = undefined;
        }
      });
    },
  },
};
</script>

<style scoped>
.handle-box {
  margin-bottom: 20px;
}

.handle-select {
  width: 120px;
}

.handle-input {
  width: 300px;
  display: inline-block;
}

.table {
  width: 100%;
  font-size: 14px;
}

.red {
  color: #ff0000;
}

.mr10 {
  margin-right: 10px;
}

.table-td-thumb {
  display: block;
  margin: auto;
  width: 40px;
  height: 40px;
}
</style>